<template>
  <div class="wrapper">
    <div class="pay-box">
      <div class="pay-tag-box">
        <h2>订单状态：{{ orderStatus[msg] }}</h2>
      </div>
    </div>

  </div>
</template>
<script src="http://res2.wx.qq.com/open/js/jweixin-1.6.0.js"></script>

<script>
import { Toast } from "cube-ui";
export default {
  name: "MyApp",
  data() {
    return {
      path: null, // 小程序页面路径
      msg: null,
      isShowHint: false,
      orderStatus:{
					"4001":"签名错误",
					"4002":"下单异常",
					"4003":"支付异常",
				}
    };
  },
  mounted() {
    this.loadWeChatSDK();
    // this.msg = "123456789";
    this.msg = this.$route.query.msg;
    this.path = `/pages/cart/payment/error?msg=${this.msg}`;
  },
  methods: {
    loadWeChatSDK() {
      const script = document.createElement("script");
      script.src = "https://res.wx.qq.com/open/js/jweixin-1.6.0.js"; // 微信SDK地址
      script.onload = () => {
        this.wx_loaded = true;

        // 检查是否加载成功
        if (typeof wx !== "undefined") {
          console.log("微信 SDK 加载成功");

          this.navigateToMiniProgramPage()
        } else {
          console.error("微信 SDK 加载失败");
        }
      };
      script.onerror = () => {
        console.error("微信 SDK 加载失败");
      };
      document.head.appendChild(script);
    },

    navigateToMiniProgramPage() {
      // 显示加载Toast并保存引用
      const loadingToast = this.showLoadingToast("正在跳转...");
      if (typeof wx === "undefined" || !wx.miniProgram) {
        console.error("微信 SDK 未正确加载或 wx.miniProgram 不可用");
        loadingToast.hide(); // 关闭加载提示
        this.showErrorToast("环境不支持跳转");
        return;
      }

      wx.miniProgram.navigateTo({
        url: this.path,
        success: (res) => {
          console.log("跳转成功", res);
          loadingToast.hide();
        },
        fail: (err) => {
          console.error("跳转失败", err);
          loadingToast.hide();
          this.showErrorToast("跳转失败");
        },
        complete: () => {
          // 确保无论如何都会关闭loading
          loadingToast.hide();
        },
      });
    },

    // 显示加载中Toast
    showLoadingToast(txt = "加载中...") {
      return Toast.$create({
        txt,
        type: "loading",
        time: 0, // 不自动关闭
        mask: true,
      }).show(); // 直接显示并返回实例
    },

    // 显示错误提示Toast
    showErrorToast(txt = "操作失败") {
      Toast.$create({
        txt,
        type: "error",
        time: 2000,
        mask: false,
      }).show();
    },

    // 使用 wx.miniProgram 功能
  },
};
</script>
<style >
h2 {
  font-size: 40px;
  text-align: left;
}

.subscribe {
  justify-content: space-between;
  align-items: center;
  margin: 0 auto 40px auto;
  padding: 0 20px 20px;
  width: 80%;
}

.pay-btns {
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  color: #fff;

  
}
.pay-btns >div{
  padding: 6px 12px;
    border: 1px solid #fff;
    border-radius: 100px;
}

.pay-money {
  line-height: 1;
  font-size: 50px;
  color: #fff;
  margin-bottom: 100px;
}

.pay-item {
  font-weight: bold;
  margin: 32px 0;
  display: flex;
  justify-content: space-between;
  font-size: 24px;

}

.pay-box {
  overflow: hidden;
}

.pay-tag-box {
  width: 80%;
  margin: 80px auto 40px auto;
  padding: 20px;
  border-radius: 20px;



}

.pay-wrapper {
  background-image: linear-gradient(90deg, #fa123b, #ff6b35, #ff9f28, #ffcc03);
  height: 480px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.pay-box {
  transform: translateY(-100px);
  width: 100%;
  background: #fff;

}
</style>
